import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { label: '网红塌房', path: '/category/wanghong-tafang' },
      { label: '娱乐吃瓜', path: '/category/yule-chigua' },
      { label: '黑料大瓜', path: '/category/heiliao-dagua' },
    ],
  },
  {
    title: '快速入口',
    links: [
      { label: '每日大赛', path: '/category/daily-contest' },
      { label: '实时追踪', path: '/category/shishi-zhuizong' },
      { label: '八卦爆料', path: '/category/bagua-baoliao' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '隐私政策', path: '/about#privacy' },
    ],
  },
  {
    title: '更多资源',
    links: [
      { label: 'APP下载', path: '/#download' },
      { label: '最新地址', path: '/' },
      { label: 'RSS订阅', path: '/#rss' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            {/* Left - Brand */}
            <div className="lg:w-[380px] flex-shrink-0">
              <Link to="/" className="flex items-center gap-3 mb-6">
                <div className="w-11 h-11 rounded-xl bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-background-50 text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <span className="text-xl font-bold font-heading text-background-50 block leading-tight">
                    吃瓜网
                  </span>
                  <span className="text-xs text-foreground-300 block leading-tight">
                    每日大赛
                  </span>
                </div>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed mb-6">
                吃瓜网每日大赛 — 国内领先的娱乐八卦与网红爆料资讯平台。
                每日更新最新猛料，实时追踪网络热门事件，做你最值得信赖的吃瓜伙伴。
              </p>
              {/* Newsletter */}
              <div className="flex items-center gap-2">
                <div className="relative flex-1 max-w-[280px]">
                  <input
                    type="email"
                    placeholder="输入邮箱订阅爆料"
                    className="w-full bg-transparent border border-foreground-600 text-background-50 text-sm px-4 py-2.5 rounded-full focus:outline-none focus:border-primary-500 transition-colors placeholder:text-foreground-500"
                  />
                </div>
                <button className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center hover:bg-primary-600 transition-colors flex-shrink-0 cursor-pointer">
                  <i className="ri-mail-send-line text-background-50 text-sm w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
            </div>

            {/* Right - Links */}
            <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
              {footerLinks.map((col) => (
                <div key={col.title}>
                  <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                    {col.title}
                  </h4>
                  <ul className="flex flex-col gap-3">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.path}
                          className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-700">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 text-center sm:text-left">
              &copy; 2026 吃瓜网每日大赛 版权所有 | 专注每日吃瓜爆料与网红黑料更新
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 rounded-lg border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}